/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.13.2.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IAPIClient {
    deleteCommercialLoanApplication(request: DeleteCommercialLoanApplicationRequest): Observable<ResultOfBoolean>;
    deleteCommercialLoanApplication2(request: DeleteCommercialLoanApplicationRequest): Observable<ResultOfBoolean>;
    saveCommercialLoanApplication(request: SaveCommercialLoanApplicationRequest): Observable<ResultOfSaveCommercialLoanApplicationResponse>;
    saveCommercialLoanApplication2(request: SaveCommercialLoanApplicationRequest): Observable<ResultOfSaveCommercialLoanApplicationResponse>;
    getCommercialLoanApplicationList(request: GetCommercialLoanApplicationListRequest): Observable<ResultOfGetCommercialLoanApplicationListResponse>;
    getCommercialLoanApplicationList2(request: GetCommercialLoanApplicationListRequest): Observable<ResultOfGetCommercialLoanApplicationListResponse>;
    getCommercialLoanApplicationForOtherSignerList(request: GetCommercialLoanApplicationForOtherSignerListRequest): Observable<ResultOfGetCommercialLoanApplicationForOtherSignerListResponse>;
    getCommercialLoanApplicationForOtherSignerList2(request: GetCommercialLoanApplicationForOtherSignerListRequest): Observable<ResultOfGetCommercialLoanApplicationForOtherSignerListResponse>;
    getCommercialLoanApplicationListNew(request: GetCommercialLoanApplicationListRequest): Observable<ResultOfGetCommercialLoanApplicationListResponse>;
    getCommercialLoanApplicationListNew2(request: GetCommercialLoanApplicationListRequest): Observable<ResultOfGetCommercialLoanApplicationListResponse>;
    getAdminCommercialLoanApplicationList(request: GetAdminCommercialLoanApplicationListRequest): Observable<ResultOfGetAdminCommercialLoanApplicationListResponse>;
    getAdminCommercialLoanApplicationList2(request: GetAdminCommercialLoanApplicationListRequest): Observable<ResultOfGetAdminCommercialLoanApplicationListResponse>;
    getCommercialLoanApplication(request: GetCommercialLoanApplicationRequest): Observable<ResultOfGetCommercialLoanApplicationResponse>;
    getCommercialLoanApplication2(request: GetCommercialLoanApplicationRequest): Observable<ResultOfGetCommercialLoanApplicationResponse>;
    getCommercialLoanApplicationInternal(request: GetCommercialLoanApplicationRequestInternal): Observable<ResultOfGetCommercialLoanApplicationResponse>;
    getCommercialLoanApplicationInternal2(request: GetCommercialLoanApplicationRequestInternal): Observable<ResultOfGetCommercialLoanApplicationResponse>;
    sendTestEmail(): Observable<ResultOfBoolean>;
    sendTestEmail2(): Observable<ResultOfBoolean>;
    postCommercialLoanApplicationPdf(commercialLoanApplicationId: string | null | undefined, pdf: FileParameter | null | undefined, validationToken: string | null | undefined): Observable<ResultOfBoolean>;
    postCommercialLoanApplicationPdf2(commercialLoanApplicationId: string | null | undefined, pdf: FileParameter | null | undefined, validationToken: string | null | undefined): Observable<ResultOfBoolean>;
    getCommercialLoanApplicationPdf(request: GetCommercialLoanApplicationRequest): Observable<ResultOfString>;
    getCommercialLoanApplicationPdf2(request: GetCommercialLoanApplicationRequest): Observable<ResultOfString>;
    postCommercialLoanApplicationAttachedFiles(commercialLoanApplicationId: string | null | undefined, signerId: string | null | undefined, fileId: string | null | undefined, fileType: string | null | undefined, fileExtension: string | null | undefined, originalFileName: string | null | undefined, attachedFile: FileParameter | null | undefined, validationToken: string | null | undefined): Observable<ResultOfBoolean>;
    postCommercialLoanApplicationAttachedFiles2(commercialLoanApplicationId: string | null | undefined, signerId: string | null | undefined, fileId: string | null | undefined, fileType: string | null | undefined, fileExtension: string | null | undefined, originalFileName: string | null | undefined, attachedFile: FileParameter | null | undefined, validationToken: string | null | undefined): Observable<ResultOfBoolean>;
    getCommercialLoanApplicationAttachedFiles(request: GetCommercialLoanApplicationAttachedFilesRequest): Observable<ResultOfString>;
    getCommercialLoanApplicationAttachedFiles2(request: GetCommercialLoanApplicationAttachedFilesRequest): Observable<ResultOfString>;
    deleteCommercialLoanApplicationAttachedFile(request: DeleteCommercialLoanApplicationAttachedFileRequest): Observable<ResultOfBoolean>;
    deleteCommercialLoanApplicationAttachedFile2(request: DeleteCommercialLoanApplicationAttachedFileRequest): Observable<ResultOfBoolean>;
    isNumberValid(request: UserNumberValidationRequest): Observable<ResultOfUserNumberValidationResponse>;
    isNumberValid2(request: UserNumberValidationRequest): Observable<ResultOfUserNumberValidationResponse>;
    healthCheck(): Observable<string>;
    healthCheck2(): Observable<string>;
    lookupTerm(): Observable<ResultOfLookupOf>;
    lookupTerm2(): Observable<ResultOfLookupOf>;
    lookupLoanType(): Observable<ResultOfLookupOf>;
    lookupLoanType2(): Observable<ResultOfLookupOf>;
    lookupLoanPurpose(): Observable<ResultOfLookupOf>;
    lookupLoanPurpose2(): Observable<ResultOfLookupOf>;
    lookupEntityType(): Observable<ResultOfLookupOf>;
    lookupEntityType2(): Observable<ResultOfLookupOf>;
    lookupApplicantRole(): Observable<ResultOfLookupOf>;
    lookupApplicantRole2(): Observable<ResultOfLookupOf>;
    lookupState(): Observable<ResultOfLookupOf>;
    lookupState2(): Observable<ResultOfLookupOf>;
    lookupCollateralType(): Observable<ResultOfLookupOf>;
    lookupCollateralType2(): Observable<ResultOfLookupOf>;
    saveSignerForThisApplication(request: SaveSignerForThisApplicationRequest): Observable<ResultOfSaveSignerForThisApplicationResponse>;
    saveSignerForThisApplication2(request: SaveSignerForThisApplicationRequest): Observable<ResultOfSaveSignerForThisApplicationResponse>;
    getSignerForThisApplication(request: GetSignerForThisApplicationRequest): Observable<ResultOfGetSignerForThisApplicationResponse>;
    getSignerForThisApplication2(request: GetSignerForThisApplicationRequest): Observable<ResultOfGetSignerForThisApplicationResponse>;
    sendUserVerificationCode(request: SendUserVerificationCodeRequest): Observable<ResultOfSendUserVerificationCodeResponse>;
    sendUserVerificationCode2(request: SendUserVerificationCodeRequest): Observable<ResultOfSendUserVerificationCodeResponse>;
    verifyCode(request: VerifyCodeRequest): Observable<ResultOfVerifyCodeResponse>;
    verifyCode2(request: VerifyCodeRequest): Observable<ResultOfVerifyCodeResponse>;
    isAuthenticated(request: BaseValidatedRequest): Observable<ResultOfValidationInfo>;
    isAuthenticated2(request: BaseValidatedRequest): Observable<ResultOfValidationInfo>;
}

@Injectable()
export class APIClient implements IAPIClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    deleteCommercialLoanApplication(request: DeleteCommercialLoanApplicationRequest): Observable<ResultOfBoolean> {
        let url_ = this.baseUrl + "/Prod/DeleteCommercialLoanApplication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCommercialLoanApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCommercialLoanApplication(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfBoolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfBoolean>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteCommercialLoanApplication(response: HttpResponseBase): Observable<ResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfBoolean>(<any>null);
    }

    deleteCommercialLoanApplication2(request: DeleteCommercialLoanApplicationRequest): Observable<ResultOfBoolean> {
        let url_ = this.baseUrl + "/Dev/DeleteCommercialLoanApplication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCommercialLoanApplication2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCommercialLoanApplication2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfBoolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfBoolean>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteCommercialLoanApplication2(response: HttpResponseBase): Observable<ResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfBoolean>(<any>null);
    }

    saveCommercialLoanApplication(request: SaveCommercialLoanApplicationRequest): Observable<ResultOfSaveCommercialLoanApplicationResponse> {
        let url_ = this.baseUrl + "/Prod/SaveCommercialLoanApplication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveCommercialLoanApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveCommercialLoanApplication(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfSaveCommercialLoanApplicationResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfSaveCommercialLoanApplicationResponse>><any>_observableThrow(response_);
        }));
    }

    protected processSaveCommercialLoanApplication(response: HttpResponseBase): Observable<ResultOfSaveCommercialLoanApplicationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfSaveCommercialLoanApplicationResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfSaveCommercialLoanApplicationResponse>(<any>null);
    }

    saveCommercialLoanApplication2(request: SaveCommercialLoanApplicationRequest): Observable<ResultOfSaveCommercialLoanApplicationResponse> {
        let url_ = this.baseUrl + "/Dev/SaveCommercialLoanApplication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveCommercialLoanApplication2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveCommercialLoanApplication2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfSaveCommercialLoanApplicationResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfSaveCommercialLoanApplicationResponse>><any>_observableThrow(response_);
        }));
    }

    protected processSaveCommercialLoanApplication2(response: HttpResponseBase): Observable<ResultOfSaveCommercialLoanApplicationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfSaveCommercialLoanApplicationResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfSaveCommercialLoanApplicationResponse>(<any>null);
    }

    getCommercialLoanApplicationList(request: GetCommercialLoanApplicationListRequest): Observable<ResultOfGetCommercialLoanApplicationListResponse> {
        let url_ = this.baseUrl + "/Prod/GetCommercialLoanApplicationList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommercialLoanApplicationList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommercialLoanApplicationList(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfGetCommercialLoanApplicationListResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfGetCommercialLoanApplicationListResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetCommercialLoanApplicationList(response: HttpResponseBase): Observable<ResultOfGetCommercialLoanApplicationListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfGetCommercialLoanApplicationListResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetCommercialLoanApplicationListResponse>(<any>null);
    }

    getCommercialLoanApplicationList2(request: GetCommercialLoanApplicationListRequest): Observable<ResultOfGetCommercialLoanApplicationListResponse> {
        let url_ = this.baseUrl + "/Dev/GetCommercialLoanApplicationList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommercialLoanApplicationList2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommercialLoanApplicationList2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfGetCommercialLoanApplicationListResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfGetCommercialLoanApplicationListResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetCommercialLoanApplicationList2(response: HttpResponseBase): Observable<ResultOfGetCommercialLoanApplicationListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfGetCommercialLoanApplicationListResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetCommercialLoanApplicationListResponse>(<any>null);
    }

    getCommercialLoanApplicationForOtherSignerList(request: GetCommercialLoanApplicationForOtherSignerListRequest): Observable<ResultOfGetCommercialLoanApplicationForOtherSignerListResponse> {
        let url_ = this.baseUrl + "/Prod/GetCommercialLoanApplicationForOtherSignerList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommercialLoanApplicationForOtherSignerList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommercialLoanApplicationForOtherSignerList(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfGetCommercialLoanApplicationForOtherSignerListResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfGetCommercialLoanApplicationForOtherSignerListResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetCommercialLoanApplicationForOtherSignerList(response: HttpResponseBase): Observable<ResultOfGetCommercialLoanApplicationForOtherSignerListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfGetCommercialLoanApplicationForOtherSignerListResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetCommercialLoanApplicationForOtherSignerListResponse>(<any>null);
    }

    getCommercialLoanApplicationForOtherSignerList2(request: GetCommercialLoanApplicationForOtherSignerListRequest): Observable<ResultOfGetCommercialLoanApplicationForOtherSignerListResponse> {
        let url_ = this.baseUrl + "/Dev/GetCommercialLoanApplicationForOtherSignerList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommercialLoanApplicationForOtherSignerList2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommercialLoanApplicationForOtherSignerList2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfGetCommercialLoanApplicationForOtherSignerListResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfGetCommercialLoanApplicationForOtherSignerListResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetCommercialLoanApplicationForOtherSignerList2(response: HttpResponseBase): Observable<ResultOfGetCommercialLoanApplicationForOtherSignerListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfGetCommercialLoanApplicationForOtherSignerListResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetCommercialLoanApplicationForOtherSignerListResponse>(<any>null);
    }

    getCommercialLoanApplicationListNew(request: GetCommercialLoanApplicationListRequest): Observable<ResultOfGetCommercialLoanApplicationListResponse> {
        let url_ = this.baseUrl + "/Prod/GetCommercialLoanApplicationListNew";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommercialLoanApplicationListNew(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommercialLoanApplicationListNew(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfGetCommercialLoanApplicationListResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfGetCommercialLoanApplicationListResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetCommercialLoanApplicationListNew(response: HttpResponseBase): Observable<ResultOfGetCommercialLoanApplicationListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfGetCommercialLoanApplicationListResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetCommercialLoanApplicationListResponse>(<any>null);
    }

    getCommercialLoanApplicationListNew2(request: GetCommercialLoanApplicationListRequest): Observable<ResultOfGetCommercialLoanApplicationListResponse> {
        let url_ = this.baseUrl + "/Dev/GetCommercialLoanApplicationListNew";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommercialLoanApplicationListNew2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommercialLoanApplicationListNew2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfGetCommercialLoanApplicationListResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfGetCommercialLoanApplicationListResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetCommercialLoanApplicationListNew2(response: HttpResponseBase): Observable<ResultOfGetCommercialLoanApplicationListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfGetCommercialLoanApplicationListResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetCommercialLoanApplicationListResponse>(<any>null);
    }

    getAdminCommercialLoanApplicationList(request: GetAdminCommercialLoanApplicationListRequest): Observable<ResultOfGetAdminCommercialLoanApplicationListResponse> {
        let url_ = this.baseUrl + "/Prod/GetAdminCommercialLoanApplicationList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdminCommercialLoanApplicationList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdminCommercialLoanApplicationList(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfGetAdminCommercialLoanApplicationListResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfGetAdminCommercialLoanApplicationListResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetAdminCommercialLoanApplicationList(response: HttpResponseBase): Observable<ResultOfGetAdminCommercialLoanApplicationListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfGetAdminCommercialLoanApplicationListResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetAdminCommercialLoanApplicationListResponse>(<any>null);
    }

    getAdminCommercialLoanApplicationList2(request: GetAdminCommercialLoanApplicationListRequest): Observable<ResultOfGetAdminCommercialLoanApplicationListResponse> {
        let url_ = this.baseUrl + "/Dev/GetAdminCommercialLoanApplicationList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdminCommercialLoanApplicationList2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdminCommercialLoanApplicationList2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfGetAdminCommercialLoanApplicationListResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfGetAdminCommercialLoanApplicationListResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetAdminCommercialLoanApplicationList2(response: HttpResponseBase): Observable<ResultOfGetAdminCommercialLoanApplicationListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfGetAdminCommercialLoanApplicationListResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetAdminCommercialLoanApplicationListResponse>(<any>null);
    }

    getCommercialLoanApplication(request: GetCommercialLoanApplicationRequest): Observable<ResultOfGetCommercialLoanApplicationResponse> {
        let url_ = this.baseUrl + "/Prod/GetCommercialLoanApplication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommercialLoanApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommercialLoanApplication(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfGetCommercialLoanApplicationResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfGetCommercialLoanApplicationResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetCommercialLoanApplication(response: HttpResponseBase): Observable<ResultOfGetCommercialLoanApplicationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfGetCommercialLoanApplicationResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetCommercialLoanApplicationResponse>(<any>null);
    }

    getCommercialLoanApplication2(request: GetCommercialLoanApplicationRequest): Observable<ResultOfGetCommercialLoanApplicationResponse> {
        let url_ = this.baseUrl + "/Dev/GetCommercialLoanApplication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommercialLoanApplication2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommercialLoanApplication2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfGetCommercialLoanApplicationResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfGetCommercialLoanApplicationResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetCommercialLoanApplication2(response: HttpResponseBase): Observable<ResultOfGetCommercialLoanApplicationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfGetCommercialLoanApplicationResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetCommercialLoanApplicationResponse>(<any>null);
    }

    getCommercialLoanApplicationInternal(request: GetCommercialLoanApplicationRequestInternal): Observable<ResultOfGetCommercialLoanApplicationResponse> {
        let url_ = this.baseUrl + "/Prod/GetCommercialLoanApplicationInternal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommercialLoanApplicationInternal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommercialLoanApplicationInternal(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfGetCommercialLoanApplicationResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfGetCommercialLoanApplicationResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetCommercialLoanApplicationInternal(response: HttpResponseBase): Observable<ResultOfGetCommercialLoanApplicationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfGetCommercialLoanApplicationResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetCommercialLoanApplicationResponse>(<any>null);
    }

    getCommercialLoanApplicationInternal2(request: GetCommercialLoanApplicationRequestInternal): Observable<ResultOfGetCommercialLoanApplicationResponse> {
        let url_ = this.baseUrl + "/Dev/GetCommercialLoanApplicationInternal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommercialLoanApplicationInternal2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommercialLoanApplicationInternal2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfGetCommercialLoanApplicationResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfGetCommercialLoanApplicationResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetCommercialLoanApplicationInternal2(response: HttpResponseBase): Observable<ResultOfGetCommercialLoanApplicationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfGetCommercialLoanApplicationResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetCommercialLoanApplicationResponse>(<any>null);
    }

    sendTestEmail(): Observable<ResultOfBoolean> {
        let url_ = this.baseUrl + "/Prod/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTestEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestEmail(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfBoolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfBoolean>><any>_observableThrow(response_);
        }));
    }

    protected processSendTestEmail(response: HttpResponseBase): Observable<ResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfBoolean>(<any>null);
    }

    sendTestEmail2(): Observable<ResultOfBoolean> {
        let url_ = this.baseUrl + "/Dev/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTestEmail2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestEmail2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfBoolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfBoolean>><any>_observableThrow(response_);
        }));
    }

    protected processSendTestEmail2(response: HttpResponseBase): Observable<ResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfBoolean>(<any>null);
    }

    postCommercialLoanApplicationPdf(commercialLoanApplicationId: string | null | undefined, pdf: FileParameter | null | undefined, validationToken: string | null | undefined): Observable<ResultOfBoolean> {
        let url_ = this.baseUrl + "/Prod/PostCommercialLoanApplicationPdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (commercialLoanApplicationId !== null && commercialLoanApplicationId !== undefined)
            content_.append("CommercialLoanApplicationId", commercialLoanApplicationId.toString());
        if (pdf !== null && pdf !== undefined)
            content_.append("Pdf", pdf.data, pdf.fileName ? pdf.fileName : "Pdf");
        if (validationToken !== null && validationToken !== undefined)
            content_.append("ValidationToken", validationToken.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostCommercialLoanApplicationPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostCommercialLoanApplicationPdf(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfBoolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfBoolean>><any>_observableThrow(response_);
        }));
    }

    protected processPostCommercialLoanApplicationPdf(response: HttpResponseBase): Observable<ResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfBoolean>(<any>null);
    }

    postCommercialLoanApplicationPdf2(commercialLoanApplicationId: string | null | undefined, pdf: FileParameter | null | undefined, validationToken: string | null | undefined): Observable<ResultOfBoolean> {
        let url_ = this.baseUrl + "/Dev/PostCommercialLoanApplicationPdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (commercialLoanApplicationId !== null && commercialLoanApplicationId !== undefined)
            content_.append("CommercialLoanApplicationId", commercialLoanApplicationId.toString());
        if (pdf !== null && pdf !== undefined)
            content_.append("Pdf", pdf.data, pdf.fileName ? pdf.fileName : "Pdf");
        if (validationToken !== null && validationToken !== undefined)
            content_.append("ValidationToken", validationToken.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostCommercialLoanApplicationPdf2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostCommercialLoanApplicationPdf2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfBoolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfBoolean>><any>_observableThrow(response_);
        }));
    }

    protected processPostCommercialLoanApplicationPdf2(response: HttpResponseBase): Observable<ResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfBoolean>(<any>null);
    }

    getCommercialLoanApplicationPdf(request: GetCommercialLoanApplicationRequest): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/Prod/GetCommercialLoanApplicationPdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommercialLoanApplicationPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommercialLoanApplicationPdf(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfString>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfString>><any>_observableThrow(response_);
        }));
    }

    protected processGetCommercialLoanApplicationPdf(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfString>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(<any>null);
    }

    getCommercialLoanApplicationPdf2(request: GetCommercialLoanApplicationRequest): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/Dev/GetCommercialLoanApplicationPdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommercialLoanApplicationPdf2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommercialLoanApplicationPdf2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfString>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfString>><any>_observableThrow(response_);
        }));
    }

    protected processGetCommercialLoanApplicationPdf2(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfString>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(<any>null);
    }

    postCommercialLoanApplicationAttachedFiles(commercialLoanApplicationId: string | null | undefined, signerId: string | null | undefined, fileId: string | null | undefined, fileType: string | null | undefined, fileExtension: string | null | undefined, originalFileName: string | null | undefined, attachedFile: FileParameter | null | undefined, validationToken: string | null | undefined): Observable<ResultOfBoolean> {
        let url_ = this.baseUrl + "/Prod/PostCommercialLoanApplicationAttachedFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (commercialLoanApplicationId !== null && commercialLoanApplicationId !== undefined)
            content_.append("CommercialLoanApplicationId", commercialLoanApplicationId.toString());
        if (signerId !== null && signerId !== undefined)
            content_.append("SignerId", signerId.toString());
        if (fileId !== null && fileId !== undefined)
            content_.append("FileId", fileId.toString());
        if (fileType !== null && fileType !== undefined)
            content_.append("FileType", fileType.toString());
        if (fileExtension !== null && fileExtension !== undefined)
            content_.append("FileExtension", fileExtension.toString());
        if (originalFileName !== null && originalFileName !== undefined)
            content_.append("OriginalFileName", originalFileName.toString());
        if (attachedFile !== null && attachedFile !== undefined)
            content_.append("AttachedFile", attachedFile.data, attachedFile.fileName ? attachedFile.fileName : "AttachedFile");
        if (validationToken !== null && validationToken !== undefined)
            content_.append("ValidationToken", validationToken.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostCommercialLoanApplicationAttachedFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostCommercialLoanApplicationAttachedFiles(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfBoolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfBoolean>><any>_observableThrow(response_);
        }));
    }

    protected processPostCommercialLoanApplicationAttachedFiles(response: HttpResponseBase): Observable<ResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfBoolean>(<any>null);
    }

    postCommercialLoanApplicationAttachedFiles2(commercialLoanApplicationId: string | null | undefined, signerId: string | null | undefined, fileId: string | null | undefined, fileType: string | null | undefined, fileExtension: string | null | undefined, originalFileName: string | null | undefined, attachedFile: FileParameter | null | undefined, validationToken: string | null | undefined): Observable<ResultOfBoolean> {
        let url_ = this.baseUrl + "/Dev/PostCommercialLoanApplicationAttachedFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (commercialLoanApplicationId !== null && commercialLoanApplicationId !== undefined)
            content_.append("CommercialLoanApplicationId", commercialLoanApplicationId.toString());
        if (signerId !== null && signerId !== undefined)
            content_.append("SignerId", signerId.toString());
        if (fileId !== null && fileId !== undefined)
            content_.append("FileId", fileId.toString());
        if (fileType !== null && fileType !== undefined)
            content_.append("FileType", fileType.toString());
        if (fileExtension !== null && fileExtension !== undefined)
            content_.append("FileExtension", fileExtension.toString());
        if (originalFileName !== null && originalFileName !== undefined)
            content_.append("OriginalFileName", originalFileName.toString());
        if (attachedFile !== null && attachedFile !== undefined)
            content_.append("AttachedFile", attachedFile.data, attachedFile.fileName ? attachedFile.fileName : "AttachedFile");
        if (validationToken !== null && validationToken !== undefined)
            content_.append("ValidationToken", validationToken.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostCommercialLoanApplicationAttachedFiles2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostCommercialLoanApplicationAttachedFiles2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfBoolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfBoolean>><any>_observableThrow(response_);
        }));
    }

    protected processPostCommercialLoanApplicationAttachedFiles2(response: HttpResponseBase): Observable<ResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfBoolean>(<any>null);
    }

    getCommercialLoanApplicationAttachedFiles(request: GetCommercialLoanApplicationAttachedFilesRequest): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/Prod/GetCommercialLoanApplicationAttachedFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommercialLoanApplicationAttachedFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommercialLoanApplicationAttachedFiles(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfString>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfString>><any>_observableThrow(response_);
        }));
    }

    protected processGetCommercialLoanApplicationAttachedFiles(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfString>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(<any>null);
    }

    getCommercialLoanApplicationAttachedFiles2(request: GetCommercialLoanApplicationAttachedFilesRequest): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/Dev/GetCommercialLoanApplicationAttachedFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommercialLoanApplicationAttachedFiles2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommercialLoanApplicationAttachedFiles2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfString>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfString>><any>_observableThrow(response_);
        }));
    }

    protected processGetCommercialLoanApplicationAttachedFiles2(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfString>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(<any>null);
    }

    deleteCommercialLoanApplicationAttachedFile(request: DeleteCommercialLoanApplicationAttachedFileRequest): Observable<ResultOfBoolean> {
        let url_ = this.baseUrl + "/Prod/DeleteCommercialLoanApplicationAttachedFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCommercialLoanApplicationAttachedFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCommercialLoanApplicationAttachedFile(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfBoolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfBoolean>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteCommercialLoanApplicationAttachedFile(response: HttpResponseBase): Observable<ResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfBoolean>(<any>null);
    }

    deleteCommercialLoanApplicationAttachedFile2(request: DeleteCommercialLoanApplicationAttachedFileRequest): Observable<ResultOfBoolean> {
        let url_ = this.baseUrl + "/Dev/DeleteCommercialLoanApplicationAttachedFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCommercialLoanApplicationAttachedFile2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCommercialLoanApplicationAttachedFile2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfBoolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfBoolean>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteCommercialLoanApplicationAttachedFile2(response: HttpResponseBase): Observable<ResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfBoolean>(<any>null);
    }

    isNumberValid(request: UserNumberValidationRequest): Observable<ResultOfUserNumberValidationResponse> {
        let url_ = this.baseUrl + "/Prod/IsNumberValid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsNumberValid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsNumberValid(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfUserNumberValidationResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfUserNumberValidationResponse>><any>_observableThrow(response_);
        }));
    }

    protected processIsNumberValid(response: HttpResponseBase): Observable<ResultOfUserNumberValidationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfUserNumberValidationResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfUserNumberValidationResponse>(<any>null);
    }

    isNumberValid2(request: UserNumberValidationRequest): Observable<ResultOfUserNumberValidationResponse> {
        let url_ = this.baseUrl + "/Dev/IsNumberValid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsNumberValid2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsNumberValid2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfUserNumberValidationResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfUserNumberValidationResponse>><any>_observableThrow(response_);
        }));
    }

    protected processIsNumberValid2(response: HttpResponseBase): Observable<ResultOfUserNumberValidationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfUserNumberValidationResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfUserNumberValidationResponse>(<any>null);
    }

    healthCheck(): Observable<string> {
        let url_ = this.baseUrl + "/Prod/HealthCheck";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHealthCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHealthCheck(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processHealthCheck(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    healthCheck2(): Observable<string> {
        let url_ = this.baseUrl + "/Dev/HealthCheck";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHealthCheck2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHealthCheck2(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processHealthCheck2(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    lookupTerm(): Observable<ResultOfLookupOf> {
        let url_ = this.baseUrl + "/Prod/Lookup/Term";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookupTerm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookupTerm(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfLookupOf>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfLookupOf>><any>_observableThrow(response_);
        }));
    }

    protected processLookupTerm(response: HttpResponseBase): Observable<ResultOfLookupOf> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfLookupOf>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfLookupOf>(<any>null);
    }

    lookupTerm2(): Observable<ResultOfLookupOf> {
        let url_ = this.baseUrl + "/Dev/Lookup/Term";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookupTerm2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookupTerm2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfLookupOf>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfLookupOf>><any>_observableThrow(response_);
        }));
    }

    protected processLookupTerm2(response: HttpResponseBase): Observable<ResultOfLookupOf> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfLookupOf>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfLookupOf>(<any>null);
    }

    lookupLoanType(): Observable<ResultOfLookupOf> {
        let url_ = this.baseUrl + "/Prod/Lookup/LoanType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookupLoanType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookupLoanType(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfLookupOf>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfLookupOf>><any>_observableThrow(response_);
        }));
    }

    protected processLookupLoanType(response: HttpResponseBase): Observable<ResultOfLookupOf> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfLookupOf>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfLookupOf>(<any>null);
    }

    lookupLoanType2(): Observable<ResultOfLookupOf> {
        let url_ = this.baseUrl + "/Dev/Lookup/LoanType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookupLoanType2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookupLoanType2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfLookupOf>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfLookupOf>><any>_observableThrow(response_);
        }));
    }

    protected processLookupLoanType2(response: HttpResponseBase): Observable<ResultOfLookupOf> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfLookupOf>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfLookupOf>(<any>null);
    }

    lookupLoanPurpose(): Observable<ResultOfLookupOf> {
        let url_ = this.baseUrl + "/Prod/Lookup/LoanPurpose";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookupLoanPurpose(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookupLoanPurpose(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfLookupOf>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfLookupOf>><any>_observableThrow(response_);
        }));
    }

    protected processLookupLoanPurpose(response: HttpResponseBase): Observable<ResultOfLookupOf> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfLookupOf>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfLookupOf>(<any>null);
    }

    lookupLoanPurpose2(): Observable<ResultOfLookupOf> {
        let url_ = this.baseUrl + "/Dev/Lookup/LoanPurpose";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookupLoanPurpose2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookupLoanPurpose2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfLookupOf>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfLookupOf>><any>_observableThrow(response_);
        }));
    }

    protected processLookupLoanPurpose2(response: HttpResponseBase): Observable<ResultOfLookupOf> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfLookupOf>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfLookupOf>(<any>null);
    }

    lookupEntityType(): Observable<ResultOfLookupOf> {
        let url_ = this.baseUrl + "/Prod/Lookup/EntityType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookupEntityType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookupEntityType(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfLookupOf>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfLookupOf>><any>_observableThrow(response_);
        }));
    }

    protected processLookupEntityType(response: HttpResponseBase): Observable<ResultOfLookupOf> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfLookupOf>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfLookupOf>(<any>null);
    }

    lookupEntityType2(): Observable<ResultOfLookupOf> {
        let url_ = this.baseUrl + "/Dev/Lookup/EntityType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookupEntityType2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookupEntityType2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfLookupOf>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfLookupOf>><any>_observableThrow(response_);
        }));
    }

    protected processLookupEntityType2(response: HttpResponseBase): Observable<ResultOfLookupOf> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfLookupOf>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfLookupOf>(<any>null);
    }

    lookupApplicantRole(): Observable<ResultOfLookupOf> {
        let url_ = this.baseUrl + "/Prod/Lookup/ApplicantRole";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookupApplicantRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookupApplicantRole(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfLookupOf>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfLookupOf>><any>_observableThrow(response_);
        }));
    }

    protected processLookupApplicantRole(response: HttpResponseBase): Observable<ResultOfLookupOf> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfLookupOf>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfLookupOf>(<any>null);
    }

    lookupApplicantRole2(): Observable<ResultOfLookupOf> {
        let url_ = this.baseUrl + "/Dev/Lookup/ApplicantRole";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookupApplicantRole2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookupApplicantRole2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfLookupOf>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfLookupOf>><any>_observableThrow(response_);
        }));
    }

    protected processLookupApplicantRole2(response: HttpResponseBase): Observable<ResultOfLookupOf> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfLookupOf>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfLookupOf>(<any>null);
    }

    lookupState(): Observable<ResultOfLookupOf> {
        let url_ = this.baseUrl + "/Prod/Lookup/State";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookupState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookupState(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfLookupOf>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfLookupOf>><any>_observableThrow(response_);
        }));
    }

    protected processLookupState(response: HttpResponseBase): Observable<ResultOfLookupOf> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfLookupOf>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfLookupOf>(<any>null);
    }

    lookupState2(): Observable<ResultOfLookupOf> {
        let url_ = this.baseUrl + "/Dev/Lookup/State";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookupState2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookupState2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfLookupOf>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfLookupOf>><any>_observableThrow(response_);
        }));
    }

    protected processLookupState2(response: HttpResponseBase): Observable<ResultOfLookupOf> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfLookupOf>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfLookupOf>(<any>null);
    }

    lookupCollateralType(): Observable<ResultOfLookupOf> {
        let url_ = this.baseUrl + "/Prod/Lookup/CollateralType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookupCollateralType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookupCollateralType(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfLookupOf>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfLookupOf>><any>_observableThrow(response_);
        }));
    }

    protected processLookupCollateralType(response: HttpResponseBase): Observable<ResultOfLookupOf> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfLookupOf>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfLookupOf>(<any>null);
    }

    lookupCollateralType2(): Observable<ResultOfLookupOf> {
        let url_ = this.baseUrl + "/Dev/Lookup/CollateralType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookupCollateralType2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookupCollateralType2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfLookupOf>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfLookupOf>><any>_observableThrow(response_);
        }));
    }

    protected processLookupCollateralType2(response: HttpResponseBase): Observable<ResultOfLookupOf> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfLookupOf>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfLookupOf>(<any>null);
    }

    saveSignerForThisApplication(request: SaveSignerForThisApplicationRequest): Observable<ResultOfSaveSignerForThisApplicationResponse> {
        let url_ = this.baseUrl + "/Prod/SaveSignerForThisApplication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveSignerForThisApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveSignerForThisApplication(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfSaveSignerForThisApplicationResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfSaveSignerForThisApplicationResponse>><any>_observableThrow(response_);
        }));
    }

    protected processSaveSignerForThisApplication(response: HttpResponseBase): Observable<ResultOfSaveSignerForThisApplicationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfSaveSignerForThisApplicationResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfSaveSignerForThisApplicationResponse>(<any>null);
    }

    saveSignerForThisApplication2(request: SaveSignerForThisApplicationRequest): Observable<ResultOfSaveSignerForThisApplicationResponse> {
        let url_ = this.baseUrl + "/Dev/SaveSignerForThisApplication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveSignerForThisApplication2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveSignerForThisApplication2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfSaveSignerForThisApplicationResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfSaveSignerForThisApplicationResponse>><any>_observableThrow(response_);
        }));
    }

    protected processSaveSignerForThisApplication2(response: HttpResponseBase): Observable<ResultOfSaveSignerForThisApplicationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfSaveSignerForThisApplicationResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfSaveSignerForThisApplicationResponse>(<any>null);
    }

    getSignerForThisApplication(request: GetSignerForThisApplicationRequest): Observable<ResultOfGetSignerForThisApplicationResponse> {
        let url_ = this.baseUrl + "/Prod/GetSignerForThisApplication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSignerForThisApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSignerForThisApplication(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfGetSignerForThisApplicationResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfGetSignerForThisApplicationResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetSignerForThisApplication(response: HttpResponseBase): Observable<ResultOfGetSignerForThisApplicationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfGetSignerForThisApplicationResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetSignerForThisApplicationResponse>(<any>null);
    }

    getSignerForThisApplication2(request: GetSignerForThisApplicationRequest): Observable<ResultOfGetSignerForThisApplicationResponse> {
        let url_ = this.baseUrl + "/Dev/GetSignerForThisApplication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSignerForThisApplication2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSignerForThisApplication2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfGetSignerForThisApplicationResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfGetSignerForThisApplicationResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetSignerForThisApplication2(response: HttpResponseBase): Observable<ResultOfGetSignerForThisApplicationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfGetSignerForThisApplicationResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetSignerForThisApplicationResponse>(<any>null);
    }

    sendUserVerificationCode(request: SendUserVerificationCodeRequest): Observable<ResultOfSendUserVerificationCodeResponse> {
        let url_ = this.baseUrl + "/Prod/SendUserVerification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendUserVerificationCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendUserVerificationCode(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfSendUserVerificationCodeResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfSendUserVerificationCodeResponse>><any>_observableThrow(response_);
        }));
    }

    protected processSendUserVerificationCode(response: HttpResponseBase): Observable<ResultOfSendUserVerificationCodeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfSendUserVerificationCodeResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfSendUserVerificationCodeResponse>(<any>null);
    }

    sendUserVerificationCode2(request: SendUserVerificationCodeRequest): Observable<ResultOfSendUserVerificationCodeResponse> {
        let url_ = this.baseUrl + "/Dev/SendUserVerification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendUserVerificationCode2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendUserVerificationCode2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfSendUserVerificationCodeResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfSendUserVerificationCodeResponse>><any>_observableThrow(response_);
        }));
    }

    protected processSendUserVerificationCode2(response: HttpResponseBase): Observable<ResultOfSendUserVerificationCodeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfSendUserVerificationCodeResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfSendUserVerificationCodeResponse>(<any>null);
    }

    verifyCode(request: VerifyCodeRequest): Observable<ResultOfVerifyCodeResponse> {
        let url_ = this.baseUrl + "/Prod/VerifyCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyCode(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfVerifyCodeResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfVerifyCodeResponse>><any>_observableThrow(response_);
        }));
    }

    protected processVerifyCode(response: HttpResponseBase): Observable<ResultOfVerifyCodeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfVerifyCodeResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfVerifyCodeResponse>(<any>null);
    }

    verifyCode2(request: VerifyCodeRequest): Observable<ResultOfVerifyCodeResponse> {
        let url_ = this.baseUrl + "/Dev/VerifyCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyCode2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyCode2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfVerifyCodeResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfVerifyCodeResponse>><any>_observableThrow(response_);
        }));
    }

    protected processVerifyCode2(response: HttpResponseBase): Observable<ResultOfVerifyCodeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfVerifyCodeResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfVerifyCodeResponse>(<any>null);
    }

    isAuthenticated(request: BaseValidatedRequest): Observable<ResultOfValidationInfo> {
        let url_ = this.baseUrl + "/Prod/IsAuthenticated";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsAuthenticated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsAuthenticated(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfValidationInfo>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfValidationInfo>><any>_observableThrow(response_);
        }));
    }

    protected processIsAuthenticated(response: HttpResponseBase): Observable<ResultOfValidationInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfValidationInfo>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfValidationInfo>(<any>null);
    }

    isAuthenticated2(request: BaseValidatedRequest): Observable<ResultOfValidationInfo> {
        let url_ = this.baseUrl + "/Dev/IsAuthenticated";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsAuthenticated2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsAuthenticated2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfValidationInfo>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfValidationInfo>><any>_observableThrow(response_);
        }));
    }

    protected processIsAuthenticated2(response: HttpResponseBase): Observable<ResultOfValidationInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfValidationInfo>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfValidationInfo>(<any>null);
    }
}

export interface ICorporateAPIClient {
    getPipelineLeadList(request: GetPipelineLeadListRequest): Observable<ResultOfGetPipelineLeadListResponse>;
    getPipelineLeadList2(request: GetPipelineLeadListRequest): Observable<ResultOfGetPipelineLeadListResponse>;
    savePipelineLead(request: PipelineLead): Observable<ResultOfGuid>;
    savePipelineLead2(request: PipelineLead): Observable<ResultOfGuid>;
    deletePipelineLead(request: DeletePipelineLeadRequest): Observable<ResultOfBoolean>;
    deletePipelineLead2(request: DeletePipelineLeadRequest): Observable<ResultOfBoolean>;
    getLoanOfficerList(request: GetLoanOfficerListRequest): Observable<ResultOfGetLoanOfficerListResponse>;
    getLoanOfficerList2(request: GetLoanOfficerListRequest): Observable<ResultOfGetLoanOfficerListResponse>;
    saveLoanOfficer(request: LoanOfficer): Observable<ResultOfGuid>;
    saveLoanOfficer2(request: LoanOfficer): Observable<ResultOfGuid>;
    deleteLoanOfficer(request: DeleteLoanOfficerRequest): Observable<ResultOfBoolean>;
    deleteLoanOfficer2(request: DeleteLoanOfficerRequest): Observable<ResultOfBoolean>;
    getContactLogList(): Observable<ResultOfGetContactLogListResponse>;
    getContactLogList2(): Observable<ResultOfGetContactLogListResponse>;
    saveContactLog(request: ContactLog): Observable<ResultOfGuid>;
    saveContactLog2(request: ContactLog): Observable<ResultOfGuid>;
    deleteContactLog(request: DeleteContactLogRequest): Observable<ResultOfBoolean>;
    deleteContactLog2(request: DeleteContactLogRequest): Observable<ResultOfBoolean>;
    getEventLogList(): Observable<ResultOfGetEventLogListResponse>;
    getEventLogList2(): Observable<ResultOfGetEventLogListResponse>;
    saveEventLog(request: EventLog): Observable<ResultOfGuid>;
    saveEventLog2(request: EventLog): Observable<ResultOfGuid>;
    deleteEventLog(request: DeleteEventLogRequest): Observable<ResultOfBoolean>;
    deleteEventLog2(request: DeleteEventLogRequest): Observable<ResultOfBoolean>;
    getPipelineList(): Observable<ResultOfGetPipelineListResponse>;
    getPipelineList2(): Observable<ResultOfGetPipelineListResponse>;
    savePipeline(request: Pipeline): Observable<ResultOfGuid>;
    savePipeline2(request: Pipeline): Observable<ResultOfGuid>;
    deletePipeline(request: DeletePipelineRequest): Observable<ResultOfBoolean>;
    deletePipeline2(request: DeletePipelineRequest): Observable<ResultOfBoolean>;
    getContactLogNoteList(request: GetContactLogNoteListRequest): Observable<ResultOfGetContactLogNoteListResponse>;
    getContactLogNoteList2(request: GetContactLogNoteListRequest): Observable<ResultOfGetContactLogNoteListResponse>;
    getEventLogNoteList(request: GetEventLogNoteListRequest): Observable<ResultOfGetEventLogNoteListResponse>;
    getEventLogNoteList2(request: GetEventLogNoteListRequest): Observable<ResultOfGetEventLogNoteListResponse>;
    getPipelineLeadNoteList(request: GetPipelineLeadNoteListRequest): Observable<ResultOfGetPipelineLeadNoteListResponse>;
    getPipelineLeadNoteList2(request: GetPipelineLeadNoteListRequest): Observable<ResultOfGetPipelineLeadNoteListResponse>;
    getPipelineNoteList(request: GetPipelineNoteListRequest): Observable<ResultOfGetPipelineNoteListResponse>;
    getPipelineNoteList2(request: GetPipelineNoteListRequest): Observable<ResultOfGetPipelineNoteListResponse>;
    saveNote(request: Note): Observable<ResultOfGuid>;
    saveNote2(request: Note): Observable<ResultOfGuid>;
    deleteNote(request: DeleteNoteRequest): Observable<ResultOfBoolean>;
    deleteNote2(request: DeleteNoteRequest): Observable<ResultOfBoolean>;
}

@Injectable()
export class CorporateAPIClient implements ICorporateAPIClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getPipelineLeadList(request: GetPipelineLeadListRequest): Observable<ResultOfGetPipelineLeadListResponse> {
        let url_ = this.baseUrl + "/Prod/Pipeline/GetPipelineLeads";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPipelineLeadList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPipelineLeadList(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfGetPipelineLeadListResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfGetPipelineLeadListResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetPipelineLeadList(response: HttpResponseBase): Observable<ResultOfGetPipelineLeadListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfGetPipelineLeadListResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetPipelineLeadListResponse>(<any>null);
    }

    getPipelineLeadList2(request: GetPipelineLeadListRequest): Observable<ResultOfGetPipelineLeadListResponse> {
        let url_ = this.baseUrl + "/Dev/Pipeline/GetPipelineLeads";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPipelineLeadList2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPipelineLeadList2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfGetPipelineLeadListResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfGetPipelineLeadListResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetPipelineLeadList2(response: HttpResponseBase): Observable<ResultOfGetPipelineLeadListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfGetPipelineLeadListResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetPipelineLeadListResponse>(<any>null);
    }

    savePipelineLead(request: PipelineLead): Observable<ResultOfGuid> {
        let url_ = this.baseUrl + "/Prod/Pipeline/SavePipelineLead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSavePipelineLead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSavePipelineLead(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfGuid>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfGuid>><any>_observableThrow(response_);
        }));
    }

    protected processSavePipelineLead(response: HttpResponseBase): Observable<ResultOfGuid> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGuid>(<any>null);
    }

    savePipelineLead2(request: PipelineLead): Observable<ResultOfGuid> {
        let url_ = this.baseUrl + "/Dev/Pipeline/SavePipelineLead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSavePipelineLead2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSavePipelineLead2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfGuid>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfGuid>><any>_observableThrow(response_);
        }));
    }

    protected processSavePipelineLead2(response: HttpResponseBase): Observable<ResultOfGuid> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGuid>(<any>null);
    }

    deletePipelineLead(request: DeletePipelineLeadRequest): Observable<ResultOfBoolean> {
        let url_ = this.baseUrl + "/Prod/Pipeline/DeletePipelineLead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePipelineLead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePipelineLead(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfBoolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfBoolean>><any>_observableThrow(response_);
        }));
    }

    protected processDeletePipelineLead(response: HttpResponseBase): Observable<ResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfBoolean>(<any>null);
    }

    deletePipelineLead2(request: DeletePipelineLeadRequest): Observable<ResultOfBoolean> {
        let url_ = this.baseUrl + "/Dev/Pipeline/DeletePipelineLead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePipelineLead2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePipelineLead2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfBoolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfBoolean>><any>_observableThrow(response_);
        }));
    }

    protected processDeletePipelineLead2(response: HttpResponseBase): Observable<ResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfBoolean>(<any>null);
    }

    getLoanOfficerList(request: GetLoanOfficerListRequest): Observable<ResultOfGetLoanOfficerListResponse> {
        let url_ = this.baseUrl + "/Prod/Pipeline/GetLoanOfficers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLoanOfficerList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLoanOfficerList(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfGetLoanOfficerListResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfGetLoanOfficerListResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetLoanOfficerList(response: HttpResponseBase): Observable<ResultOfGetLoanOfficerListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfGetLoanOfficerListResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetLoanOfficerListResponse>(<any>null);
    }

    getLoanOfficerList2(request: GetLoanOfficerListRequest): Observable<ResultOfGetLoanOfficerListResponse> {
        let url_ = this.baseUrl + "/Dev/Pipeline/GetLoanOfficers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLoanOfficerList2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLoanOfficerList2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfGetLoanOfficerListResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfGetLoanOfficerListResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetLoanOfficerList2(response: HttpResponseBase): Observable<ResultOfGetLoanOfficerListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfGetLoanOfficerListResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetLoanOfficerListResponse>(<any>null);
    }

    saveLoanOfficer(request: LoanOfficer): Observable<ResultOfGuid> {
        let url_ = this.baseUrl + "/Prod/Pipeline/SaveLoanOfficer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveLoanOfficer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveLoanOfficer(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfGuid>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfGuid>><any>_observableThrow(response_);
        }));
    }

    protected processSaveLoanOfficer(response: HttpResponseBase): Observable<ResultOfGuid> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGuid>(<any>null);
    }

    saveLoanOfficer2(request: LoanOfficer): Observable<ResultOfGuid> {
        let url_ = this.baseUrl + "/Dev/Pipeline/SaveLoanOfficer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveLoanOfficer2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveLoanOfficer2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfGuid>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfGuid>><any>_observableThrow(response_);
        }));
    }

    protected processSaveLoanOfficer2(response: HttpResponseBase): Observable<ResultOfGuid> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGuid>(<any>null);
    }

    deleteLoanOfficer(request: DeleteLoanOfficerRequest): Observable<ResultOfBoolean> {
        let url_ = this.baseUrl + "/Prod/Pipeline/DeleteLoanOfficer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLoanOfficer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLoanOfficer(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfBoolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfBoolean>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteLoanOfficer(response: HttpResponseBase): Observable<ResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfBoolean>(<any>null);
    }

    deleteLoanOfficer2(request: DeleteLoanOfficerRequest): Observable<ResultOfBoolean> {
        let url_ = this.baseUrl + "/Dev/Pipeline/DeleteLoanOfficer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLoanOfficer2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLoanOfficer2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfBoolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfBoolean>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteLoanOfficer2(response: HttpResponseBase): Observable<ResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfBoolean>(<any>null);
    }

    getContactLogList(): Observable<ResultOfGetContactLogListResponse> {
        let url_ = this.baseUrl + "/Prod/Pipeline/GetContactLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactLogList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactLogList(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfGetContactLogListResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfGetContactLogListResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetContactLogList(response: HttpResponseBase): Observable<ResultOfGetContactLogListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfGetContactLogListResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetContactLogListResponse>(<any>null);
    }

    getContactLogList2(): Observable<ResultOfGetContactLogListResponse> {
        let url_ = this.baseUrl + "/Dev/Pipeline/GetContactLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactLogList2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactLogList2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfGetContactLogListResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfGetContactLogListResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetContactLogList2(response: HttpResponseBase): Observable<ResultOfGetContactLogListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfGetContactLogListResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetContactLogListResponse>(<any>null);
    }

    saveContactLog(request: ContactLog): Observable<ResultOfGuid> {
        let url_ = this.baseUrl + "/Prod/Pipeline/SaveContactLog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveContactLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveContactLog(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfGuid>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfGuid>><any>_observableThrow(response_);
        }));
    }

    protected processSaveContactLog(response: HttpResponseBase): Observable<ResultOfGuid> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGuid>(<any>null);
    }

    saveContactLog2(request: ContactLog): Observable<ResultOfGuid> {
        let url_ = this.baseUrl + "/Dev/Pipeline/SaveContactLog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveContactLog2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveContactLog2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfGuid>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfGuid>><any>_observableThrow(response_);
        }));
    }

    protected processSaveContactLog2(response: HttpResponseBase): Observable<ResultOfGuid> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGuid>(<any>null);
    }

    deleteContactLog(request: DeleteContactLogRequest): Observable<ResultOfBoolean> {
        let url_ = this.baseUrl + "/Prod/Pipeline/DeleteContactLog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteContactLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteContactLog(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfBoolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfBoolean>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteContactLog(response: HttpResponseBase): Observable<ResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfBoolean>(<any>null);
    }

    deleteContactLog2(request: DeleteContactLogRequest): Observable<ResultOfBoolean> {
        let url_ = this.baseUrl + "/Dev/Pipeline/DeleteContactLog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteContactLog2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteContactLog2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfBoolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfBoolean>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteContactLog2(response: HttpResponseBase): Observable<ResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfBoolean>(<any>null);
    }

    getEventLogList(): Observable<ResultOfGetEventLogListResponse> {
        let url_ = this.baseUrl + "/Prod/Pipeline/GetEventLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEventLogList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEventLogList(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfGetEventLogListResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfGetEventLogListResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetEventLogList(response: HttpResponseBase): Observable<ResultOfGetEventLogListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfGetEventLogListResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetEventLogListResponse>(<any>null);
    }

    getEventLogList2(): Observable<ResultOfGetEventLogListResponse> {
        let url_ = this.baseUrl + "/Dev/Pipeline/GetEventLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEventLogList2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEventLogList2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfGetEventLogListResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfGetEventLogListResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetEventLogList2(response: HttpResponseBase): Observable<ResultOfGetEventLogListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfGetEventLogListResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetEventLogListResponse>(<any>null);
    }

    saveEventLog(request: EventLog): Observable<ResultOfGuid> {
        let url_ = this.baseUrl + "/Prod/Pipeline/SaveEventLog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveEventLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveEventLog(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfGuid>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfGuid>><any>_observableThrow(response_);
        }));
    }

    protected processSaveEventLog(response: HttpResponseBase): Observable<ResultOfGuid> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGuid>(<any>null);
    }

    saveEventLog2(request: EventLog): Observable<ResultOfGuid> {
        let url_ = this.baseUrl + "/Dev/Pipeline/SaveEventLog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveEventLog2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveEventLog2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfGuid>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfGuid>><any>_observableThrow(response_);
        }));
    }

    protected processSaveEventLog2(response: HttpResponseBase): Observable<ResultOfGuid> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGuid>(<any>null);
    }

    deleteEventLog(request: DeleteEventLogRequest): Observable<ResultOfBoolean> {
        let url_ = this.baseUrl + "/Prod/Pipeline/DeleteEventLog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEventLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEventLog(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfBoolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfBoolean>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteEventLog(response: HttpResponseBase): Observable<ResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfBoolean>(<any>null);
    }

    deleteEventLog2(request: DeleteEventLogRequest): Observable<ResultOfBoolean> {
        let url_ = this.baseUrl + "/Dev/Pipeline/DeleteEventLog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEventLog2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEventLog2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfBoolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfBoolean>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteEventLog2(response: HttpResponseBase): Observable<ResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfBoolean>(<any>null);
    }

    getPipelineList(): Observable<ResultOfGetPipelineListResponse> {
        let url_ = this.baseUrl + "/Prod/Pipeline/GetPipelines";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPipelineList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPipelineList(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfGetPipelineListResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfGetPipelineListResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetPipelineList(response: HttpResponseBase): Observable<ResultOfGetPipelineListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfGetPipelineListResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetPipelineListResponse>(<any>null);
    }

    getPipelineList2(): Observable<ResultOfGetPipelineListResponse> {
        let url_ = this.baseUrl + "/Dev/Pipeline/GetPipelines";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPipelineList2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPipelineList2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfGetPipelineListResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfGetPipelineListResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetPipelineList2(response: HttpResponseBase): Observable<ResultOfGetPipelineListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfGetPipelineListResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetPipelineListResponse>(<any>null);
    }

    savePipeline(request: Pipeline): Observable<ResultOfGuid> {
        let url_ = this.baseUrl + "/Prod/Pipeline/SavePipeline";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSavePipeline(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSavePipeline(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfGuid>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfGuid>><any>_observableThrow(response_);
        }));
    }

    protected processSavePipeline(response: HttpResponseBase): Observable<ResultOfGuid> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGuid>(<any>null);
    }

    savePipeline2(request: Pipeline): Observable<ResultOfGuid> {
        let url_ = this.baseUrl + "/Dev/Pipeline/SavePipeline";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSavePipeline2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSavePipeline2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfGuid>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfGuid>><any>_observableThrow(response_);
        }));
    }

    protected processSavePipeline2(response: HttpResponseBase): Observable<ResultOfGuid> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGuid>(<any>null);
    }

    deletePipeline(request: DeletePipelineRequest): Observable<ResultOfBoolean> {
        let url_ = this.baseUrl + "/Prod/Pipeline/DeletePipeline";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePipeline(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePipeline(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfBoolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfBoolean>><any>_observableThrow(response_);
        }));
    }

    protected processDeletePipeline(response: HttpResponseBase): Observable<ResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfBoolean>(<any>null);
    }

    deletePipeline2(request: DeletePipelineRequest): Observable<ResultOfBoolean> {
        let url_ = this.baseUrl + "/Dev/Pipeline/DeletePipeline";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePipeline2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePipeline2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfBoolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfBoolean>><any>_observableThrow(response_);
        }));
    }

    protected processDeletePipeline2(response: HttpResponseBase): Observable<ResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfBoolean>(<any>null);
    }

    getContactLogNoteList(request: GetContactLogNoteListRequest): Observable<ResultOfGetContactLogNoteListResponse> {
        let url_ = this.baseUrl + "/Prod/Pipeline/GetContactLogNotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactLogNoteList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactLogNoteList(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfGetContactLogNoteListResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfGetContactLogNoteListResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetContactLogNoteList(response: HttpResponseBase): Observable<ResultOfGetContactLogNoteListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfGetContactLogNoteListResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetContactLogNoteListResponse>(<any>null);
    }

    getContactLogNoteList2(request: GetContactLogNoteListRequest): Observable<ResultOfGetContactLogNoteListResponse> {
        let url_ = this.baseUrl + "/Dev/Pipeline/GetContactLogNotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactLogNoteList2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactLogNoteList2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfGetContactLogNoteListResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfGetContactLogNoteListResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetContactLogNoteList2(response: HttpResponseBase): Observable<ResultOfGetContactLogNoteListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfGetContactLogNoteListResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetContactLogNoteListResponse>(<any>null);
    }

    getEventLogNoteList(request: GetEventLogNoteListRequest): Observable<ResultOfGetEventLogNoteListResponse> {
        let url_ = this.baseUrl + "/Prod/Pipeline/GetEventLogNotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEventLogNoteList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEventLogNoteList(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfGetEventLogNoteListResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfGetEventLogNoteListResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetEventLogNoteList(response: HttpResponseBase): Observable<ResultOfGetEventLogNoteListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfGetEventLogNoteListResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetEventLogNoteListResponse>(<any>null);
    }

    getEventLogNoteList2(request: GetEventLogNoteListRequest): Observable<ResultOfGetEventLogNoteListResponse> {
        let url_ = this.baseUrl + "/Dev/Pipeline/GetEventLogNotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEventLogNoteList2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEventLogNoteList2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfGetEventLogNoteListResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfGetEventLogNoteListResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetEventLogNoteList2(response: HttpResponseBase): Observable<ResultOfGetEventLogNoteListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfGetEventLogNoteListResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetEventLogNoteListResponse>(<any>null);
    }

    getPipelineLeadNoteList(request: GetPipelineLeadNoteListRequest): Observable<ResultOfGetPipelineLeadNoteListResponse> {
        let url_ = this.baseUrl + "/Prod/Pipeline/GetPipelineLeadNotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPipelineLeadNoteList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPipelineLeadNoteList(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfGetPipelineLeadNoteListResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfGetPipelineLeadNoteListResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetPipelineLeadNoteList(response: HttpResponseBase): Observable<ResultOfGetPipelineLeadNoteListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfGetPipelineLeadNoteListResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetPipelineLeadNoteListResponse>(<any>null);
    }

    getPipelineLeadNoteList2(request: GetPipelineLeadNoteListRequest): Observable<ResultOfGetPipelineLeadNoteListResponse> {
        let url_ = this.baseUrl + "/Dev/Pipeline/GetPipelineLeadNotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPipelineLeadNoteList2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPipelineLeadNoteList2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfGetPipelineLeadNoteListResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfGetPipelineLeadNoteListResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetPipelineLeadNoteList2(response: HttpResponseBase): Observable<ResultOfGetPipelineLeadNoteListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfGetPipelineLeadNoteListResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetPipelineLeadNoteListResponse>(<any>null);
    }

    getPipelineNoteList(request: GetPipelineNoteListRequest): Observable<ResultOfGetPipelineNoteListResponse> {
        let url_ = this.baseUrl + "/Prod/Pipeline/GetContactNotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPipelineNoteList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPipelineNoteList(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfGetPipelineNoteListResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfGetPipelineNoteListResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetPipelineNoteList(response: HttpResponseBase): Observable<ResultOfGetPipelineNoteListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfGetPipelineNoteListResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetPipelineNoteListResponse>(<any>null);
    }

    getPipelineNoteList2(request: GetPipelineNoteListRequest): Observable<ResultOfGetPipelineNoteListResponse> {
        let url_ = this.baseUrl + "/Dev/Pipeline/GetContactNotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPipelineNoteList2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPipelineNoteList2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfGetPipelineNoteListResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfGetPipelineNoteListResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetPipelineNoteList2(response: HttpResponseBase): Observable<ResultOfGetPipelineNoteListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfGetPipelineNoteListResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetPipelineNoteListResponse>(<any>null);
    }

    saveNote(request: Note): Observable<ResultOfGuid> {
        let url_ = this.baseUrl + "/Prod/Pipeline/SaveNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveNote(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfGuid>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfGuid>><any>_observableThrow(response_);
        }));
    }

    protected processSaveNote(response: HttpResponseBase): Observable<ResultOfGuid> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGuid>(<any>null);
    }

    saveNote2(request: Note): Observable<ResultOfGuid> {
        let url_ = this.baseUrl + "/Dev/Pipeline/SaveNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveNote2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveNote2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfGuid>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfGuid>><any>_observableThrow(response_);
        }));
    }

    protected processSaveNote2(response: HttpResponseBase): Observable<ResultOfGuid> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGuid>(<any>null);
    }

    deleteNote(request: DeleteNoteRequest): Observable<ResultOfBoolean> {
        let url_ = this.baseUrl + "/Prod/Pipeline/DeleteNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteNote(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfBoolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfBoolean>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteNote(response: HttpResponseBase): Observable<ResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfBoolean>(<any>null);
    }

    deleteNote2(request: DeleteNoteRequest): Observable<ResultOfBoolean> {
        let url_ = this.baseUrl + "/Dev/Pipeline/DeleteNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteNote2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteNote2(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfBoolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultOfBoolean>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteNote2(response: HttpResponseBase): Observable<ResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfBoolean>(<any>null);
    }
}

export interface ResultOfBoolean {
    data: boolean;
    errorMessage?: string | undefined;
    isSuccess: boolean;
}

export interface DeleteCommercialLoanApplicationRequest {
    commercialLoanApplicationId?: string | undefined;
}

export interface ResultOfSaveCommercialLoanApplicationResponse {
    data?: SaveCommercialLoanApplicationResponse | undefined;
    errorMessage?: string | undefined;
    isSuccess: boolean;
}

export interface SaveCommercialLoanApplicationResponse {
    isSaveSuccessful: boolean;
    commercialLoanApplicationId?: string | undefined;
    signerForThisApplicationList?: SignerForThisApplication[] | undefined;
}

export interface SignerForThisApplication {
    signerForThisApplicationId?: string | undefined;
    orderBy: number;
    name?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    title?: string | undefined;
    emailAddress?: string | undefined;
    ssn?: string | undefined;
    streetAddress?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    phone?: string | undefined;
    signature?: string | undefined;
    attachedFileList?: AttachedFile[] | undefined;
}

export interface AttachedFile {
    attachedFileId?: string | undefined;
    originalName?: string | undefined;
    fileType?: string | undefined;
    fileId?: string | undefined;
}

export interface SaveCommercialLoanApplicationRequest {
    commercialLoanApplication?: CommercialLoanApplication | undefined;
    phoneNumber?: string | undefined;
}

export interface CommercialLoanApplication {
    commercialLoanApplicationId?: string | undefined;
    creditRequested?: CreditRequested | undefined;
    applicantInformation?: ApplicantInformation | undefined;
    scheduleOfCollateralOfferedByThisApplicantList?: ScheduleOfCollateralOfferedByThisApplicant[] | undefined;
    financialAndIncomeStatementSummary?: FinancialAndIncomeStatementSummary | undefined;
    relationshipInformation?: RelationshipInformation | undefined;
    signerForThisApplicationList?: SignerForThisApplication[] | undefined;
    commercialLoanApplicationState?: string | undefined;
    isSubmitted: boolean;
    status?: string | undefined;
    loanOfficerRequested?: string | undefined;
    loanOfficerRequestedGUID?: string | undefined;
    loanOfficerGUID?: string | undefined;
    clientUserGUID?: string | undefined;
}

export interface CreditRequested {
    amountRequested?: number | undefined;
    termCreditRequested?: number | undefined;
    termCreditRequestedOther?: string | undefined;
    loanType?: number | undefined;
    loanTypeOther?: string | undefined;
    marketSurvey?: string | undefined;
    purposeOfCreditRequest?: string | undefined;
    appNumber?: string | undefined;
    applicant?: string | undefined;
    emailAddress?: string | undefined;
    coApplicants?: string[] | undefined;
    isJointCoApplicant: boolean;
}

export interface ApplicantInformation {
    applicantPreferredFirstName?: string | undefined;
    applicantPreferredMiddleName?: string | undefined;
    applicantPreferredSuffix?: string | undefined;
    ssnTin?: string | undefined;
    applicantType?: number | undefined;
    applicantTypeOther?: string | undefined;
    applicantIs?: string | undefined;
    stateOfOrganization?: string | undefined;
    incomeType?: string | undefined;
    maritalStatus?: string | undefined;
    primaryStreetAddress?: string | undefined;
    primaryCity?: string | undefined;
    primaryState?: string | undefined;
    primaryZipCode?: string | undefined;
    primaryPhone?: string | undefined;
    mailingStreetAddress?: string | undefined;
    mailingCity?: string | undefined;
    mailingState?: string | undefined;
    mailingZipCode?: string | undefined;
    officeStreetAddress?: string | undefined;
    officeCity?: string | undefined;
    officeState?: string | undefined;
    officeZipCode?: string | undefined;
    dbas?: Dba[] | undefined;
}

export interface Dba {
    dbaId?: string | undefined;
    assumedBusinessName?: string | undefined;
    filingDate?: Date | undefined;
    filingLocation?: string | undefined;
}

export interface ScheduleOfCollateralOfferedByThisApplicant {
    scheduleOfCollateralOfferedByThisApplicantId?: string | undefined;
    collateralTypeLU?: string | undefined;
    collateralTypeOther?: string | undefined;
    description?: string | undefined;
    value?: number | undefined;
    totalLiens?: number | undefined;
    creditorName?: string | undefined;
    isPurchaseMoney: boolean;
    isPresentlyOwned: boolean;
}

export interface FinancialAndIncomeStatementSummary {
    totalAssets?: number | undefined;
    totalAnnualIncome?: number | undefined;
    totalLiabilities?: number | undefined;
    totalAnnualExpenses?: number | undefined;
    netWorth?: number | undefined;
    netAnnualCashFlow?: number | undefined;
}

export interface RelationshipInformation {
    isNewCustomer: boolean;
    isExistingCustomer: boolean;
    customerSinceDate?: Date | undefined;
    lastFinancialStatementDate?: Date | undefined;
    lastTaxReturnDateOnFile?: Date | undefined;
    lastCreditReportDate?: Date | undefined;
    lastCreditBureauDate?: Date | undefined;
    liabilitiesWithLenderDirect?: number | undefined;
    liabilitiesWithLenderContingent?: number | undefined;
    liabilitiesWithLenderTotal?: number | undefined;
    depositsWithLenderDDAAvg?: number | undefined;
    depositsWithLenderOtherAvg?: number | undefined;
    depositsWithLenderTotalAvg?: number | undefined;
    totalCreditWithLenderNewCredit?: number | undefined;
    totalCreditWithLenderProposedTotal?: number | undefined;
}

export interface ResultOfGetCommercialLoanApplicationListResponse {
    data?: GetCommercialLoanApplicationListResponse | undefined;
    errorMessage?: string | undefined;
    isSuccess: boolean;
}

export interface GetCommercialLoanApplicationListResponse {
    commercialLoanApplicationList?: CommercialLoanApplicationListItem[] | undefined;
}

export interface CommercialLoanApplicationListItem {
    commercialLoanApplicationId?: string | undefined;
    lastModifiedDateTimeUTC: Date;
    amountRequested?: number | undefined;
    loanType?: number | undefined;
    isSubmitted?: boolean | undefined;
    totalSigners?: number | undefined;
    totalSignedSigners?: number | undefined;
}

export interface GetCommercialLoanApplicationListRequest {
    phoneNumber?: string | undefined;
}

export interface ResultOfGetCommercialLoanApplicationForOtherSignerListResponse {
    data?: GetCommercialLoanApplicationForOtherSignerListResponse | undefined;
    errorMessage?: string | undefined;
    isSuccess: boolean;
}

export interface GetCommercialLoanApplicationForOtherSignerListResponse {
    commercialLoanApplicationForOtherSignerList?: CommercialLoanApplicationForOtherSignerListItem[] | undefined;
}

export interface CommercialLoanApplicationForOtherSignerListItem {
    commercialLoanApplicationId?: string | undefined;
    lastModifiedDateTimeUTC: Date;
    amountRequested?: number | undefined;
    loanType?: number | undefined;
    isSubmitted?: boolean | undefined;
    totalSigners?: number | undefined;
    totalSignedSigners?: number | undefined;
}

export interface GetCommercialLoanApplicationForOtherSignerListRequest {
    phoneNumber?: string | undefined;
}

export interface ResultOfGetAdminCommercialLoanApplicationListResponse {
    data?: GetAdminCommercialLoanApplicationListResponse | undefined;
    errorMessage?: string | undefined;
    isSuccess: boolean;
}

export interface GetAdminCommercialLoanApplicationListResponse {
    adminCommercialLoanApplicationListItems?: GetAdminCommercialLoanApplicationListItem[] | undefined;
}

export interface GetAdminCommercialLoanApplicationListItem {
    applicantPreferredFirstName?: string | undefined;
    applicant?: string | undefined;
    applicantPreferredMiddleName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    amountRequested?: number | undefined;
    status?: string | undefined;
    loanType?: number | undefined;
    loanTypeOther?: number | undefined;
    lastModifiedDateTimeUTC: Date;
}

export interface GetAdminCommercialLoanApplicationListRequest {
}

export interface ResultOfGetCommercialLoanApplicationResponse {
    data?: GetCommercialLoanApplicationResponse | undefined;
    errorMessage?: string | undefined;
    isSuccess: boolean;
}

export interface GetCommercialLoanApplicationResponse {
    commercialLoanApplication?: CommercialLoanApplication | undefined;
}

export interface GetCommercialLoanApplicationRequest {
    commercialLoanApplicationId?: string | undefined;
    signerId?: string | undefined;
}

export interface GetCommercialLoanApplicationRequestInternal {
    commercialLoanApplicationId?: string | undefined;
}

export interface ResultOfString {
    data?: string | undefined;
    errorMessage?: string | undefined;
    isSuccess: boolean;
}

export interface BaseValidatedRequest {
    validationToken?: string | undefined;
}

export interface GetCommercialLoanApplicationAttachedFilesRequest extends BaseValidatedRequest {
    commercialLoanApplicationId?: string | undefined;
    signerId?: string | undefined;
    fileId?: string | undefined;
    fileExtension?: string | undefined;
    attachedFileBase64?: string | undefined;
}

export interface DeleteCommercialLoanApplicationAttachedFileRequest extends BaseValidatedRequest {
    attachedFileId?: string | undefined;
    fileId?: string | undefined;
}

export interface ResultOfUserNumberValidationResponse {
    data?: UserNumberValidationResponse | undefined;
    errorMessage?: string | undefined;
    isSuccess: boolean;
}

export interface UserNumberValidationResponse {
    isApprovedSigner: boolean;
    authenticatedUserPhoneNumber?: string | undefined;
}

export interface UserNumberValidationRequest {
    phoneNumber?: string | undefined;
    signerID?: string | undefined;
    applicaitonId?: string | undefined;
}

export interface ResultOfLookupOf {
    data?: Lookup[] | undefined;
    errorMessage?: string | undefined;
    isSuccess: boolean;
}

export interface Lookup {
    id?: string | undefined;
    optionalValue?: number | undefined;
    label?: string | undefined;
    sortOrder: number;
    isOther: boolean;
}

export interface ResultOfSaveSignerForThisApplicationResponse {
    data?: SaveSignerForThisApplicationResponse | undefined;
    errorMessage?: string | undefined;
    isSuccess: boolean;
}

export interface SaveSignerForThisApplicationResponse {
    signerForThisApplication?: SignerForThisApplication | undefined;
}

export interface SaveSignerForThisApplicationRequest {
    commercialLoanApplicationId: string;
    signerForThisApplication?: SignerForThisApplication | undefined;
    isSubmit: boolean;
    phoneNumber?: string | undefined;
}

export interface ResultOfGetSignerForThisApplicationResponse {
    data?: GetSignerForThisApplicationResponse | undefined;
    errorMessage?: string | undefined;
    isSuccess: boolean;
}

export interface GetSignerForThisApplicationResponse {
    signerForThisApplication?: SignerForThisApplication | undefined;
}

export interface GetSignerForThisApplicationRequest {
    signerForThisApplicationId?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface ResultOfSendUserVerificationCodeResponse {
    data?: SendUserVerificationCodeResponse | undefined;
    errorMessage?: string | undefined;
    isSuccess: boolean;
}

export interface SendUserVerificationCodeResponse {
    serviceSid?: string | undefined;
    verifyName?: string | undefined;
}

export interface SendUserVerificationCodeRequest {
    phone?: string | undefined;
    verificationCodeType?: string | undefined;
}

export interface ResultOfVerifyCodeResponse {
    data?: VerifyCodeResponse | undefined;
    errorMessage?: string | undefined;
    isSuccess: boolean;
}

export interface VerifyCodeResponse {
    verifySuccessful: boolean;
    phone?: string | undefined;
    validationToken?: string | undefined;
}

export interface VerifyCodeRequest {
    serviceSid?: string | undefined;
    phone?: string | undefined;
    code?: string | undefined;
}

export interface ResultOfValidationInfo {
    data?: ValidationInfo | undefined;
    errorMessage?: string | undefined;
    isSuccess: boolean;
}

export interface ValidationInfo {
    phoneNumber?: string | undefined;
    isValidated: boolean;
}

export interface ResultOfGetPipelineLeadListResponse {
    data?: GetPipelineLeadListResponse | undefined;
    errorMessage?: string | undefined;
    isSuccess: boolean;
}

export interface PaginationResponseBase {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    totalRowCount?: number | undefined;
}

export interface GetPipelineLeadListResponse extends PaginationResponseBase {
    pipelineLeadList?: PipelineLeadListItem[] | undefined;
}

export interface PipelineLeadListItem {
    pipelineLeadId?: string | undefined;
    pipelineLeadName?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    firstContact: Date;
    lastContact: Date;
    loanOfficerId?: string | undefined;
    loanOfficerName?: string | undefined;
    pipelineLeadStatus?: string | undefined;
}

export interface PaginationRequestBase {
    sortColumns?: SortColumn[] | undefined;
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
}

export interface GetPipelineLeadListRequest extends PaginationRequestBase {
    name?: string | undefined;
    loanOfficer?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    beginFirstContact?: Date | undefined;
    endFirstContact?: Date | undefined;
    beginLastContact?: Date | undefined;
    endLastContact?: Date | undefined;
    status?: string | undefined;
}

export interface SortColumn {
    columnName?: string | undefined;
    isAscending: boolean;
}

export interface ResultOfGuid {
    data: string;
    errorMessage?: string | undefined;
    isSuccess: boolean;
}

export interface PipelineLead {
    pipelineLeadId?: string | undefined;
    loanOfficerId?: string | undefined;
    name?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    firstContact?: Date | undefined;
    lastContact?: Date | undefined;
    status?: string | undefined;
}

export interface DeletePipelineLeadRequest {
    pipelineLeadId?: string | undefined;
}

export interface ResultOfGetLoanOfficerListResponse {
    data?: GetLoanOfficerListResponse | undefined;
    errorMessage?: string | undefined;
    isSuccess: boolean;
}

export interface GetLoanOfficerListResponse extends PaginationResponseBase {
    loanOfficerList?: LoanOfficerListItem[] | undefined;
}

export interface LoanOfficerListItem {
    loanOfficerId?: string | undefined;
    loanOfficerName?: string | undefined;
}

export interface GetLoanOfficerListRequest extends PaginationRequestBase {
    name?: string | undefined;
}

export interface LoanOfficer {
    loanOfficerId?: string | undefined;
    name?: string | undefined;
}

export interface DeleteLoanOfficerRequest {
    loanOfficerId?: string | undefined;
}

export interface ResultOfGetContactLogListResponse {
    data?: GetContactLogListResponse | undefined;
    errorMessage?: string | undefined;
    isSuccess: boolean;
}

export interface GetContactLogListResponse {
    contactLogList?: ContactLogListItem[] | undefined;
}

export interface ContactLogListItem {
    contactLogId?: string | undefined;
    contactDateTime: Date;
    method?: string | undefined;
    result?: string | undefined;
    pipelineLeadId?: string | undefined;
    pipelineLeadName?: string | undefined;
}

export interface ContactLog {
    contactLogId?: string | undefined;
    pipelineLeadId?: string | undefined;
    method?: string | undefined;
    result?: string | undefined;
    contactDateTime: Date;
}

export interface DeleteContactLogRequest {
    contactLogId?: string | undefined;
}

export interface ResultOfGetEventLogListResponse {
    data?: GetEventLogListResponse | undefined;
    errorMessage?: string | undefined;
    isSuccess: boolean;
}

export interface GetEventLogListResponse {
    eventLogList?: EventLogListItem[] | undefined;
}

export interface EventLogListItem {
    eventLogId?: string | undefined;
    dueFor?: string | undefined;
    dueDateTime?: Date | undefined;
    event?: string | undefined;
    eventLevel?: string | undefined;
    eventType?: string | undefined;
    eventTarget?: string | undefined;
    eventDescription?: string | undefined;
    actionDateTime?: Date | undefined;
    result?: string | undefined;
}

export interface EventLog {
    eventLogId?: string | undefined;
    dueFor?: string | undefined;
    dueDateTime?: Date | undefined;
    event?: string | undefined;
    eventLevel?: string | undefined;
    eventType?: string | undefined;
    eventTarget?: string | undefined;
    eventDescription?: string | undefined;
    actionDateTime?: Date | undefined;
    result?: string | undefined;
}

export interface DeleteEventLogRequest {
    eventLogId?: string | undefined;
}

export interface ResultOfGetPipelineListResponse {
    data?: GetPipelineListResponse | undefined;
    errorMessage?: string | undefined;
    isSuccess: boolean;
}

export interface GetPipelineListResponse {
    pipelineList?: PipelineListItem[] | undefined;
}

export interface PipelineListItem {
    pipelineId?: string | undefined;
    projectName?: string | undefined;
    projectDescription?: string | undefined;
    projectType?: string | undefined;
    projectAmount?: number | undefined;
    projectDate?: Date | undefined;
    pipelineLeadId?: string | undefined;
    pipelineLeadName?: string | undefined;
}

export interface Pipeline {
    pipelineId?: string | undefined;
    pipelineLeadId?: string | undefined;
    projectName?: string | undefined;
    projectDescription?: string | undefined;
    projectType?: string | undefined;
    projectAmount?: number | undefined;
    projectDate?: Date | undefined;
}

export interface DeletePipelineRequest {
    pipelineId?: string | undefined;
}

export interface ResultOfGetContactLogNoteListResponse {
    data?: GetContactLogNoteListResponse | undefined;
    errorMessage?: string | undefined;
    isSuccess: boolean;
}

export interface GetContactLogNoteListResponse {
    noteList?: NoteListItem[] | undefined;
}

export interface NoteListItem {
    noteId?: string | undefined;
    noteText?: string | undefined;
    noteDateTime?: Date | undefined;
}

export interface GetContactLogNoteListRequest {
    contactLogId?: string | undefined;
}

export interface ResultOfGetEventLogNoteListResponse {
    data?: GetEventLogNoteListResponse | undefined;
    errorMessage?: string | undefined;
    isSuccess: boolean;
}

export interface GetEventLogNoteListResponse {
    noteList?: NoteListItem[] | undefined;
}

export interface GetEventLogNoteListRequest {
    eventLogId?: string | undefined;
}

export interface ResultOfGetPipelineLeadNoteListResponse {
    data?: GetPipelineLeadNoteListResponse | undefined;
    errorMessage?: string | undefined;
    isSuccess: boolean;
}

export interface GetPipelineLeadNoteListResponse {
    noteList?: NoteListItem[] | undefined;
}

export interface GetPipelineLeadNoteListRequest {
    pipelineLeadId?: string | undefined;
}

export interface ResultOfGetPipelineNoteListResponse {
    data?: GetPipelineNoteListResponse | undefined;
    errorMessage?: string | undefined;
    isSuccess: boolean;
}

export interface GetPipelineNoteListResponse {
    noteList?: NoteListItem[] | undefined;
}

export interface GetPipelineNoteListRequest {
    pipelineId?: string | undefined;
}

export interface Note {
    noteId?: string | undefined;
    noteText?: string | undefined;
    noteDateTime?: Date | undefined;
}

export interface DeleteNoteRequest {
    noteId?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}